import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AppMaterialModule } from "./app-material.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { DirectivesModule } from "./directives/directives.module";
import { ComponentsModule } from "./components/components.module";
import { PipesModule } from "./pipes/pipes.module";
import { MerriCommonModule } from "@merri/common";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppMaterialModule,
    DirectivesModule,
    ComponentsModule,
    PipesModule,
    MerriCommonModule,
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppMaterialModule,
    DirectivesModule,
    ComponentsModule,
    PipesModule,
    MerriCommonModule,
  ],
})
export class SharedModule {}
